// App configuration. The relay URL is provided at build time via VITE_RELAY_URL
// (federation-ready: it's just a home-relay address). Empty => relay disabled,
// and sync becomes a no-op until configured.

import { RelayClient } from './relay';

export const RELAY_URL: string = import.meta.env.VITE_RELAY_URL ?? '';

export const relay = new RelayClient(RELAY_URL);
